import { IHeSoUuTienTKB } from "../../../model/respone/category/IHeSoUuTienTKB";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHeSoUuTienTKBActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IHeSoUuTienTKB[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IHeSoUuTienTKB | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IHeSoUuTienTKB,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",
};

export const eHeSoUuTienTKBActionIds = generateActionTypeIds(
  eHeSoUuTienTKBActionsObj,
  "HE_SO_UU_TIEN_TKB"
);

export type IHeSoUuTienTKBActionTypes = IGenericActionType<
  typeof eHeSoUuTienTKBActionsObj,
  "HE_SO_UU_TIEN_TKB"
>;
